import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { trackVisit } from "./lib/api";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Success from "./pages/Success";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminExport from "./pages/AdminExport";
import AdminMessages from "./pages/AdminMessages";
import Badge from "./pages/Badge";
import Status from "./pages/Status";
import Scanner from "./pages/Scanner";

function App() {
  useEffect(() => {
    // Don't track admin pages
    if (!window.location.pathname.startsWith("/admin")) {
      trackVisit();
    }
  }, []);

  return (
    <div className="App">
      <Toaster
        position="top-center"
        dir="rtl"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E5E5E5",
            color: "#0A0A0A",
            fontFamily: "Tajawal, sans-serif",
            borderRadius: 0,
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/success/:code" element={<Success />} />
          <Route path="/track" element={<Status />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/scanner" element={<Scanner />} />
          <Route path="/admin/export" element={<AdminExport />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/badge/:code" element={<Badge />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
